module.exports = __webpack_public_path__ + "img/ico-products.bc0d6b4.svg";